import React from 'react';
import { observer } from 'mobx-react-lite';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

const NewChatButton = observer(({ compact = false }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const onClick = async () => {
        try {
            await chatStore.newChat();
        } catch (e) {
            console.error(e);
        }
    };

    if (compact) {
        return (
            <button
                type="button"
                onClick={onClick}
                className={`rounded-md p-2 text-lg ${isDark ? 'hover:bg-white/10' : 'hover:bg-black/5'}`}
                title="Новый чат"
            >
                +
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={onClick}
            className={`flex-1 rounded-lg border px-3 py-2 text-sm font-medium ${
                isDark
                    ? 'border-white/15 bg-white/5 hover:bg-white/10'
                    : 'border-black/10 bg-white hover:bg-black/5'
            }`}
        >
            + Новый чат
        </button>
    );
});

export default NewChatButton;
